import DogNoDataImage from "@/assets/images/dog-cute-no-data.png"
import { appDevelopingModalPopupState } from "@/atoms/appPopupState"
import Button from "@/components/base/Button"
import { RelendModal } from "@/components/relendModal"
import useTrans from "@/hooks/useTrans"
import { Stack, Typography } from "@mui/material"
import { useAtom } from "jotai"
import Image from "next/image"

const View = () => {
  const trans = useTrans()
  const [popupState, setPopupState] = useAtom(appDevelopingModalPopupState)
  const handleCloseModal = () => {
    setPopupState({ isOpen: false })
  }

  return (
    <RelendModal
      open={popupState.isOpen}
      handleClose={handleCloseModal}
      data-testid='modal-developing-notification'
      title={trans.common.notification}
      showCloseButton
      hideButtonClose
      useDrawerOnMobile
      isSmallPopup
    >
      <Stack alignItems='center' gap={2}>
        <Image src={DogNoDataImage} alt='doge-question' width={150} />
        <Typography className='text-center text-neutral-1000 font-bold sm:text-2xl'>
          {trans.common.feature_under_development}
        </Typography>
        <Typography className='text-center text-neutral-900 sm:text-base'>
          {trans.common.sorry_feature_developing}
        </Typography>

        <Button
          size='lg'
          variant='primary'
          className='mt-4'
          fullWidth
          onClick={handleCloseModal}
          data-testid='close-dev-modal'
        >
          {trans.common.ok}
        </Button>
      </Stack>
    </RelendModal>
  )
}

export default View
